'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _abyssReact = require('abyss-react');

var _abyssReact2 = _interopRequireDefault(_abyssReact);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

var _actions = require('../actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mapResult = function mapResult(_ref) {
  var value = _ref.value,
      valueKey = _ref.valueKey,
      multi = _ref.multi,
      mapValue = _ref.mapValue;

  mapValue = mapValue || function (v) {
    return v[valueKey];
  };
  return multi ? value.map(mapValue) : mapValue(value);
};

var getDefaultValue = function getDefaultValue(_ref2) {
  var value = _ref2.value,
      valueKey = _ref2.valueKey,
      multi = _ref2.multi,
      options = _ref2.options;

  if (value) {
    if (multi) {
      var keys = options.map(function (o) {
        return o[valueKey];
      });
      value = value.filter(function (i) {
        return keys.includes(i[valueKey] || i);
      });
      value = value.length ? value : null;
    } else {
      var key = value[valueKey] || value;
      value = options.find(function (i) {
        return i[valueKey] === key;
      }) || null;
    }
  }

  return value;
};

var propTypes = {
  id: _propTypes2.default.string,
  inputProps: _propTypes2.default.object,
  className: _propTypes2.default.string,
  autoFocus: _propTypes2.default.bool,
  mapValue: _propTypes2.default.func,
  multi: _propTypes2.default.bool.isRequired,
  clearable: _propTypes2.default.bool.isRequired,
  searchable: _propTypes2.default.bool.isRequired,
  scrollMenuIntoView: _propTypes2.default.bool.isRequired,
  options: _propTypes2.default.array,
  defaultValue: _propTypes2.default.object,
  defaultSet: _propTypes2.default.bool,
  model: _propTypes2.default.string,
  validators: _propTypes2.default.object,
  field: _propTypes2.default.object.isRequired,
  modelValue: _propTypes2.default.any,
  mappedValue: _propTypes2.default.any,
  value: _propTypes2.default.any,
  localValue: _propTypes2.default.any,
  focused: _propTypes2.default.bool,
  inputRef: _propTypes2.default.object,
  setInputRef: _propTypes2.default.func,
  validateModel: _propTypes2.default.func,
  handleChange: _propTypes2.default.func,
  handleFocus: _propTypes2.default.func,
  handleBlur: _propTypes2.default.func
};

var defaultProps = {
  labelKey: 'label',
  valueKey: 'value',
  multi: false,
  clearable: false,
  searchable: false,
  scrollMenuIntoView: false
};

var defaultState = function defaultState(props) {
  return {
    localValue: props.defaultValue || null,
    mappedValue: null,
    defaultSet: false,
    focused: false
  };
};

var connectState = function connectState(state, _ref3) {
  var model = _ref3.model,
      multi = _ref3.multi;
  return {
    field: utils.getField(state, model),
    modelValue: utils.getModelValue(state, model) || (multi ? [] : null)
  };
};

var methods = {
  setInputRef: function setInputRef(_ref4, ref) {
    var setRef = _ref4.setRef;

    setRef({ inputRef: ref });
  },
  componentDidMount: function componentDidMount(_ref5) {
    var validateModel = _ref5.validateModel,
        model = _ref5.model;

    if (model) {
      validateModel();
    }
  },
  componentWillUnmount: function componentWillUnmount(_ref6) {
    var dispatch = _ref6.dispatch,
        model = _ref6.model;

    if (model) {
      setTimeout(function () {
        return dispatch(actions.unset(model));
      });
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(props, nextProps) {
    return utils.propsChanged(props, nextProps, ['value', 'localValue', 'modelValue', 'defaultValue', 'field', 'disabled', 'focused', 'options', 'isLoading']);
  },
  componentDidUpdate: function componentDidUpdate(_ref7, prevProps) {
    var field = _ref7.field,
        inputRef = _ref7.inputRef,
        validateModel = _ref7.validateModel,
        defaultSet = _ref7.defaultSet,
        defaultValue = _ref7.defaultValue,
        dispatch = _ref7.dispatch,
        model = _ref7.model,
        modelValue = _ref7.modelValue,
        localValue = _ref7.localValue,
        value = _ref7.value,
        validators = _ref7.validators,
        setState = _ref7.setState,
        multi = _ref7.multi,
        mapValue = _ref7.mapValue,
        mappedValue = _ref7.mappedValue,
        labelKey = _ref7.labelKey,
        valueKey = _ref7.valueKey,
        options = _ref7.options;

    if (model) {
      if (!prevProps.focused && field.focused) {
        inputRef.focus();
      }

      if (validators && field.validated === false) {
        validateModel();
      }

      if (!defaultSet) {
        var defaultVal = void 0;

        if (modelValue && Object.keys(modelValue).length) {
          defaultVal = modelValue;
        } else if (defaultValue && Object.keys(defaultValue).length) {
          defaultVal = defaultValue;
        }

        if (defaultVal) {
          var hasOptions = options && options.length > 0;

          if (hasOptions) {
            defaultVal = getDefaultValue({
              value: defaultVal,
              valueKey: valueKey,
              multi: multi,
              options: options
            });
          }

          if (defaultVal) {
            if ((typeof defaultVal === 'undefined' ? 'undefined' : _typeof(defaultVal)) === 'object' && Object.keys(defaultVal).length) {
              var mappedVal = mapResult({
                value: multi ? defaultVal.slice() : Object.assign({}, defaultVal),
                valueKey: valueKey,
                multi: multi,
                mapValue: mapValue
              });

              setState({
                localValue: defaultVal,
                mappedValue: mappedVal,
                defaultSet: hasOptions
              });

              if (!(0, _isEqual2.default)(modelValue, mappedVal)) {
                dispatch(actions.set(model, mappedVal, {
                  errors: utils.getErrors(mappedVal, validators)
                }));
              }
            } else if (typeof defaultVal === 'string') {
              var _localValue;

              setState({
                localValue: (_localValue = {}, _defineProperty(_localValue, labelKey, defaultVal), _defineProperty(_localValue, valueKey, defaultVal), _localValue),
                mappedValue: defaultVal,
                defaultSet: hasOptions
              });
            }
          }
        }
      } else if (!(0, _isEqual2.default)(mappedValue, modelValue)) {
        if (typeof modelValue === 'string') {
          var _localValue2;

          setState({
            localValue: (_localValue2 = {}, _defineProperty(_localValue2, labelKey, modelValue), _defineProperty(_localValue2, valueKey, modelValue), _localValue2),
            mappedValue: modelValue
          });
        } else {
          setState({
            localValue: modelValue,
            mappedValue: modelValue
          });
        }
      }
    }
  },
  validateModel: function validateModel(_ref8) {
    var setState = _ref8.setState,
        dispatch = _ref8.dispatch,
        model = _ref8.model,
        modelValue = _ref8.modelValue,
        validators = _ref8.validators;

    setState({ localValue: modelValue });
    dispatch(actions.validate(model, modelValue, {
      errors: utils.getErrors(modelValue, validators)
    }));
  },
  handleChange: function handleChange(_ref9, value) {
    var onChange = _ref9.onChange,
        multi = _ref9.multi,
        dispatch = _ref9.dispatch,
        model = _ref9.model,
        modelValue = _ref9.modelValue,
        setState = _ref9.setState,
        validators = _ref9.validators,
        mapValue = _ref9.mapValue,
        valueKey = _ref9.valueKey;

    var mappedValue = null;

    if (value) {
      mappedValue = mapResult({
        value: multi ? value.slice() : Object.assign({}, value),
        valueKey: valueKey,
        multi: multi,
        mapValue: mapValue
      });
    }

    if (model) {
      setState({
        localValue: value,
        mappedValue: mappedValue
      });

      if (mappedValue !== modelValue) {
        dispatch(actions.set(model, mappedValue, {
          errors: utils.getErrors(mappedValue, validators),
          touched: true
        }));
      }
    }

    if (onChange) {
      onChange(mappedValue);
    }
  },
  handleFocus: function handleFocus(_ref10, e) {
    var onFocus = _ref10.onFocus,
        setState = _ref10.setState;

    setState({ focused: true });

    if (onFocus) {
      onFocus(e);
    }
  },
  handleBlur: function handleBlur(_ref11, e) {
    var onBlur = _ref11.onBlur,
        dispatch = _ref11.dispatch,
        model = _ref11.model,
        field = _ref11.field,
        setState = _ref11.setState;

    if (model && (field.focused || !field.touched)) {
      setTimeout(function () {
        if (!window.__ABYSS_FORM_RESET__) {
          dispatch(actions.update(model, {
            focused: false,
            touched: true
          }));
        }
      });
    }

    setState({ focused: false });

    if (onBlur) {
      onBlur(e);
    }
  }
};

var SelectList = function SelectList(_ref12) {
  var id = _ref12.id,
      inputProps = _ref12.inputProps,
      className = _ref12.className,
      model = _ref12.model,
      value = _ref12.value,
      localValue = _ref12.localValue,
      focused = _ref12.focused,
      field = _ref12.field,
      autoFocus = _ref12.autoFocus,
      clearable = _ref12.clearable,
      searchable = _ref12.searchable,
      scrollMenuIntoView = _ref12.scrollMenuIntoView,
      options = _ref12.options,
      inputRef = _ref12.inputRef,
      setInputRef = _ref12.setInputRef,
      handleChange = _ref12.handleChange,
      handleFocus = _ref12.handleFocus,
      handleBlur = _ref12.handleBlur,
      props = _objectWithoutProperties(_ref12, ['id', 'inputProps', 'className', 'model', 'value', 'localValue', 'focused', 'field', 'autoFocus', 'clearable', 'searchable', 'scrollMenuIntoView', 'options', 'inputRef', 'setInputRef', 'handleChange', 'handleFocus', 'handleBlur']);

  delete props.mapValue;
  delete props.defaultValue;
  delete props.defaultSet;
  delete props.modelValue;
  delete props.mappedValue;
  delete props.validators;
  delete props.inputRef;
  delete props.validateModel;

  var fieldClasses = ['abyss-selectlist', 'abyss-inputbox', className];

  if (field.touched && field.changed) {
    if (field.valid) {
      fieldClasses.push('abyss-form--valid');
    } else {
      fieldClasses.push('abyss-form--invalid');
    }
  }

  if (inputRef && inputRef.control && inputRef.control.offsetWidth < 100) {
    fieldClasses.push('abyss-selectlist--small');
  }

  var fieldClassName = fieldClasses.filter(function (c) {
    return c;
  }).join(' ');

  return _react2.default.createElement(_reactSelect2.default, _extends({}, props, {
    className: fieldClassName,
    setClasses: { 'abyss-form--focused': focused },
    value: model ? localValue : value,
    instanceId: id,
    inputProps: _extends({}, inputProps, { id: id }),
    ref: setInputRef,
    options: options,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    autofocus: autoFocus,
    clearable: clearable,
    backspaceRemoves: clearable,
    searchable: searchable,
    scrollMenuIntoView: scrollMenuIntoView }));
};

SelectList.propTypes = propTypes;
SelectList.defaultProps = defaultProps;
SelectList.defaultState = defaultState;
SelectList.connectState = connectState;
SelectList.methods = methods;

exports.default = (0, _abyssReact2.default)(SelectList);


//////////////////
// WEBPACK FOOTER
// ./node_modules/abyss-form/lib/SelectList/SelectList.js
// module id = 555
// module chunks = 0